export const colorStyles = {
    control: (styles: any, { isDisabled }: { isDisabled?: boolean }) => ({
        ...styles,
        backgroundColor: isDisabled ? '#f1f0ef' : 'white',
        borderColor: 'rgb(226, 232, 240) !important',
        minHeight: '2rem',
        // ':hover': {
        //     backgroundColor: 'rgba(0, 174, 179, 0.10)',
        // },
        ':focus': {
            borderColor: '#01aeb4 !important',
            boxShadow: 'inset 0 0 0 0px #01aeb4 !important',
        },
        ':focus-within': {
            borderColor: '#01aeb4 !important',
            boxShadow: 'inset 0 0 0 0px #01aeb4 !important',
        },
    }),
    valueContainer: (styles: any) => ({
        ...styles,
        padding: '0.35rem 0.5rem',
    }),
    placeholder: (styles: any, { isDisabled }: { isDisabled?: boolean }) => ({
        ...styles,
        color: isDisabled ? '#808080' : 'black',
        whiteSpace: 'nowrap',
    }),
    dropdownIndicator: (
        styles: any,
        { isDisabled }: { isDisabled?: boolean }
    ) => ({
        ...styles,
        // paddingRight: '15px',
        color: isDisabled ? '#808080' : 'black',
    }),
    clearIndicator: (styles: any) => ({
        ...styles,
        color: 'black',
    }),
    indicatorSeparator: (styles: any) => ({
        ...styles,
        width: '0',
    }),
    menuList: (styles: any) => ({
        ...styles,
        background: 'white',
        border: '1px solid #000',
        borderRadius: '4px',
    }),
    option: (
        styles: any,
        { isFocused, isSelected }: { isFocused?: boolean; isSelected?: boolean }
    ) => ({
        ...styles,
        background: isFocused ? '#E5F6F9' : isSelected ? '#E5F6F9' : undefined,
        color: isFocused ? 'black' : isSelected ? 'black' : undefined,
        zIndex: 1,
    }),
    menu: (base: any) => ({
        ...base,
        zIndex: 1021,
        boxShadow: 'none',
    }),
};
